import React from "react";
import "../styles/MeetTheTeam.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa"; 

const teamMembers = [
  {
    name: "Sadanand Shetty",
    title: "Founder & Director",
    image: "/OurTeam/Team 5.png",
    phone: "+919724982104"
  },
  {
    name: "Sudarshan Shetty",
    title: "Regional Manager",
    image: "/OurTeam/Team 7.png",
    phone: "+919766178056"
  },
  {
    name: "Sudhir Shetty",
    title: "Regional Manager",
    image: "/OurTeam/Team 1.png",
    phone:"+917506080809"
  },
  {
    name: "Omkar Kamat",
    title: "Manager",
    image: "/OurTeam/Team 3.png",
    phone:"+917039031661"
  },
  {
    name: "Niranjan Anchan",
    title: "Manager",
    image: "/OurTeam/Team 6.png",
    phone:"+919979956569"
   },
  {
    name: "Aditya Gupta",
    title: "Manager",
    image: "/OurTeam/Team 4.png",
    phone:"+919322644194"
  },
  {
    name: "Rishi Shetty",
    title: "Administrator",
    email: "admin@laxmihospitalityservices.in",
    image: "/OurTeam/Team 2.png",
  },
];

const MeetTheTeam = () => {
  return (
    <div className="team-section">
      <h2 className="team-heading">Meet the Team</h2>
      <div className="team-container">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <img src={member.image} alt={member.name} className="team-image" />
            <h3 className="team-name">{member.name}</h3>
            <p className="team-title">{member.title}</p>
            {member.email ? (
              <p className="team-email">
                <a href={`mailto:${member.email}`} className="email-link">
                  <FaEnvelope className="email-icon" /> {member.email}
                </a>
              </p>
            ) : member.phone ? (
              <p className="team-phone">
                <a href={`tel:${member.phone.replace(/\s+/g, '')}`} className="phone-link">
                  <FaPhoneAlt className="phone-icon" /> {member.phone}
                </a>
              </p>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetTheTeam;
